export default __webpack_public_path__ + "static/media/GraceImage.b09ddce7.png";